"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayerBonusEventsLogsListCtl = /** @class */ (function (_super) {
    __extends(PlayerBonusEventsLogsListCtl, _super);
    function PlayerBonusEventsLogsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_usr_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_id; });
        _this.dk_usr_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_login; });
        _this.dk_evt_binding_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.evt_binding_id; });
        _this.dk_evt_binding_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.evt_binding_title; });
        _this.dk_player_bonus_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_bonus_id; });
        _this.dk_player_bonus_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_bonus_title; });
        _this.dk_bonus_tpl_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_tpl_id; });
        _this.dk_bonus_tpl_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_tpl_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerBonusEventsLogsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerBonusEventsLogsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player with id [" + id + "] not found !";
    };
    PlayerBonusEventsLogsListCtl.prototype.LoadRangeData = function (data, onDone) {
        var _this = this;
        webAApi_1.ListUsrPlayerBonusEventsLogsByPlayerIdAndDateRangeGet.exec({
            user_player_id: data.playerId,
            from_year: data.from_year,
            from_month: data.from_month,
            from_day: data.from_day,
            from_hour: data.from_hour,
            from_minute: data.from_minute,
            to_year: data.to_year,
            to_month: data.to_month,
            to_day: data.to_day,
            to_hour: data.to_hour,
            to_minute: data.to_minute,
            limit: data.limit,
            offset: data.offset
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    usr_player_id: resp.list[i].usr_player_id,
                    usr_player_login: resp.list[i].usr_player_login,
                    evt_binding_id: resp.list[i].evt_binding_id,
                    evt_binding_title: resp.list[i].evt_binding_title,
                    player_bonus_id: resp.list[i].player_bonus_id,
                    player_bonus_title: resp.list[i].player_bonus_title,
                    bonus_tpl_id: resp.list[i].bonus_tpl_id,
                    bonus_tpl_title: resp.list[i].bonus_tpl_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return PlayerBonusEventsLogsListCtl;
}(BaseController_1.BaseController));
exports.PlayerBonusEventsLogsListCtl = PlayerBonusEventsLogsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayerBonusEventsLogsListCtl.ts
// module id = 1044
// module chunks = 0